import { AxiosError } from 'axios';
import { CredentialType } from 'web-library/models/AccountManagementConfiguration';
import { LookupListApiItem } from '../../api/user/model';
import { POST_CREATE_CANDIDATE_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request Model
// =============================================================================
export interface CreateCandidateRequest {
  user: {
    name: string | null;
    email: string | null;
    countryCode: string | null;
    contactNumber: string | null;
    createdByUserId: number | null;
    updatedByUserId: number | null;
    enabled: boolean | null;
    dateOfBirth: string | null;
  };
  userIdType: 'nric/fin' | 'passport' | null;
  candidateId: string | null;
  hanyuPinyinName: string | null;
  gender: string | null;
  race: string | null;
  secondRace: string | null;
  nationality: string | null;
  prStatus: string | null;
  nationalityIssueDate: string | null;
  citizenship: string | null;
  occupation?: LookupListApiItem;
  organisationId: number | null;

  // addresses
  localAddressBlockNumber: string | null;
  localAddressStreetName: string | null;
  localAddressBuildingName: string | null;
  localAddressFloorNumber: string | null;
  localAddressUnitNumber: string | null;
  localAddressPostalCode: string | null;
  foreignAddress1: string | null;
  foreignAddress2: string | null;
  foreignAddress3: string | null;
  isLocalAddressPreferred: boolean | null;

  // contact numbers
  telephoneNumberCountryCode: number | 0 | null;
  telephoneNumber: string | null;
  mobileNumberCountryCode: number | null;
  mobileNumber: string | null;
  isMobileNumberPreferred: boolean | null;

  // next of kin
  nextOfKinName: string | null;
  nextOfKinRelationship: string | null;
  nextOfKinContactNumberCountryCode: number | null;
  nextOfKinContactNumber: string | null;

  iexamsId: string | null;
  credentialType: CredentialType | null;

  currentAge: number | null;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCreateCandidate = ({ onSuccess, onError }: Input = {}) => {
  const postCreateCandidate = async (reqBody: CreateCandidateRequest): Promise<void> => {
    await axiosClient.post<void>(POST_CREATE_CANDIDATE_URL, reqBody);
  };

  return useCustomMutation(
    postCreateCandidate,
    {
      onSuccess,
      onError,
    },
    false
  );
};
